"use client";

import { useSession } from "next-auth/react";
import Script from "next/script";

const MicrosoftClarity = () => {
  const { data: session } = useSession();
  const user = session?.user;
  return (
    <Script
      id="microsoft-clarity-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_MICROSOFT_CLARITY}");

                // After Clarity is initialized, pass custom data like entity_id
                var user = JSON.parse(localStorage.getItem('proz_user'));
                if (user && user.entity_id) {
                  clarity("set", "entity_id",${user?.entity_id});
                } else {
                  console.warn('User data not found or entity_id missing');
                }
                `,
      }}
    />
  );
};

export default MicrosoftClarity;
